const Resume_data = [
  {
    id: 1,
    category: "education",
    year: "(2019 - 2023)",
    title: "B.Tech (CSE)",
    desc: "Maharaja Agrasen Institute of Technology(GGSIPU)",
    rate: "9.49 / 10",
    isModal: false,
  },
  {
    id: 2,
    category: "education",
    year: "2019, Class-XII",
    title: "Senior Secondary",
    desc: "A.G.D.A.V. Centenary Public School, CBSE Board",
    rate: "94.8 %",
    isModal: false,
  },
  {
    id: 3,
    category: "education",
    year: "2017, Class 10th",
    title: "Secondary",
    desc: "A.G.D.A.V. Centenary Public School, CBSE Board",
    rate: "10 / 10",
    isModal: false,
  },
  {
    id: 4,
    category: "experience",
    year: "August, 2024 - Present",
    title: "Adpushup Software India Private Ltd.",
    desc: "Full-Stack Developer, Delhi",
    rate: null,
    details: `◦ Engineered an hourly monitoring and alerting system using scheduled jobs, improving anomaly detection efficiency by 80% and significantly reducing issue resolution times. \n
              ◦ Built and scaled automation pipelines and web scrapers to streamline workflows and support cross-functional teams. \n
              ◦ Designed and implemented custom integrations and technical solutions for 100+ partner websites, ensuring reliable ad delivery and resolving quality issues. \n
              ◦ Optimized ad delivery systems and launched high-performance ad formats, driving 10%+ revenue uplift across platforms. \n
              ◦ Developed a centralized access control system to manage user permissions and enhanced dashboards with configurable controls and advanced reporting metrics.`,
    isModal: true,
  },
  {
    id: 5,
    category: "experience",
    year: "April, 2024 - August, 2024",
    title: "3dot14, Collegedunia",
    desc: "Full-Stack Develope,r, Gurugram",
    rate: null,
    details: `◦ Developed a dynamic, high-performance landing page for the 3.14 Commerce website using Next.js, improving user engagement and overall experience.\n
              ◦ Built interactive websites to display the latest coupons, deals, and blogs, providing a user-friendly and visually captivating interface. \n
              ◦ Designed and implemented a CMS using Node.js and SQL with secure authentication, text editing, and media upload capabilities for efficient content management.`,
    isModal: true,
  },
  {
    id: 6,
    category: "experience",
    year: "Feb, 2023 - Nov, 2023",
    title: "Adani Digital Labs",
    desc: "Software Developer Trainee, Gurugram",
    rate: null,
    details: `◦ Played a key role on the Adani One Payments Team, developing critical UI components like payment failure flows and order summaries to streamline the transaction experience across multiple services.\n
              ◦ Actively contributed to the development of high-impact features for Adani Realty and Ambuja websites, focusing on creative UI design and enhanced functional components to improve user engagement. \n
              ◦ Drove codebase maintainability by introducing interfaces and refactoring legacy logic, while simultaneously resolving complex bugs across diverse projects to ensure high-quality software delivery.`,
    isModal: true,
  },
];

export default Resume_data;
